import { useTranslation } from "react-i18next";
import "./LngSwitch.css";

export default function LngSwitch() {
  const { t, i18n } = useTranslation();

  const switchLanguage = () => {
    const currentLang = localStorage.getItem("lng") || "uk";
    const newLang = currentLang === "uk" ? "en" : "uk";
    i18n.changeLanguage(newLang);
    localStorage.setItem("lng", newLang);
  };

  return (
    <div>
      <button className="btnLangSwitch" onClick={switchLanguage}>
        {t("switch")}
      </button>
    </div>
  );
}
